import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Box, Button } from 'roo-ui/components';
import theme from 'lib/theme';
import { EDITING } from 'components/StepWizard';

const StepForm = ({ children, completeStep, handleSubmit, hasState }) => {
  if (!hasState(EDITING)) return null;

  return (
    <Box p={[4, 8]}>
      <form onSubmit={handleSubmit(completeStep)}>
        <Box mb={[4, 8]} pb={[4, 8]} borderBottom={`1px solid ${theme.colors.greys.alto}`}>
          {children}
        </Box>
        <Button type="submit" variant="primary" width={['100%', 'auto']} data-testid="next-step-button">
          Continue
        </Button>
      </form>
    </Box>
  );
};

StepForm.propTypes = {
  completeStep: PropTypes.func,
  handleSubmit: PropTypes.func,
  hasState: PropTypes.func,
  children: PropTypes.node,
};

StepForm.defaultProps = {
  completeStep: noop,
  handleSubmit: noop,
  hasState: noop,
  children: null,
};

export default StepForm;
